import { AdminApi } from 'stylemix-vue-admin'

export default class PayoutsApi extends AdminApi {
  constructor(parameters) {
    super('payouts', parameters)
  }

  all(config = {}) {
    return this.submit('get', `/${this.endpoint}/my`, null, config)
  }

  process(ids, param, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/process`,
      ids ? { ids } : {},
      config,
    )
  }
}
